<template>
    <BaseCard class="flex flex-col justify-between overflow-hidden">
        <!-- Three circles icon -->
        <div class="mb-5">
            <svg aria-hidden="true" width="97" height="40" viewBox="0 0 97 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20.0007" cy="20.0002" r="19.3206" transform="rotate(-180 20.0007 20.0002)" fill="#FFE7B7" stroke="black" stroke-width="1.35848" />
                <circle cx="48.2273" cy="20.0002" r="19.3206" transform="rotate(-180 48.2273 20.0002)" fill="#80DADA" stroke="black" stroke-width="1.35848" />
                <mask id="path-3-inside-1_1711_7683" fill="white">
                    <path
                        d="M33.6568 34.1016C30.2889 30.5223 28.2242 25.7029 28.2242 20.4004C28.2242 14.6351 30.6649 9.44088 34.5679 5.79102C37.9359 9.37037 40.0005 14.1905 40.0005 19.4932C40.0004 25.2581 37.5595 30.4518 33.6568 34.1016Z" />
                </mask>
                <path
                    d="M33.6568 34.1016C30.2889 30.5223 28.2242 25.7029 28.2242 20.4004C28.2242 14.6351 30.6649 9.44088 34.5679 5.79102C37.9359 9.37037 40.0005 14.1905 40.0005 19.4932C40.0004 25.2581 37.5595 30.4518 33.6568 34.1016Z"
                    fill="#A1A5FD" />
                <path
                    d="M33.6568 34.1016L32.6674 35.0325L33.5955 36.0188L34.5847 35.0938L33.6568 34.1016ZM28.2242 20.4004L26.8657 20.4004L26.8657 20.4004L28.2242 20.4004ZM34.5679 5.79102L35.5573 4.86008L34.6292 3.87377L33.64 4.79878L34.5679 5.79102ZM40.0005 19.4932L41.359 19.4932L41.359 19.4932L40.0005 19.4932ZM33.6568 34.1016L34.6462 33.1706C31.5057 29.8331 29.5827 25.3431 29.5827 20.4004L28.2242 20.4004L26.8657 20.4004C26.8657 26.0627 29.0721 31.2115 32.6674 35.0325L33.6568 34.1016ZM28.2242 20.4004L29.5827 20.4004C29.5827 15.0269 31.8558 10.1872 35.4958 6.78325L34.5679 5.79102L33.64 4.79878C29.4741 8.69457 26.8657 14.2433 26.8657 20.4004L28.2242 20.4004ZM34.5679 5.79102L33.5786 6.72195C36.719 10.0595 38.6421 14.5503 38.6421 19.4932L40.0005 19.4932L41.359 19.4932C41.359 13.8308 39.1528 8.68122 35.5573 4.86008L34.5679 5.79102ZM40.0005 19.4932L38.6421 19.4931C38.642 24.8662 36.3687 29.7054 32.7289 33.1094L33.6568 34.1016L34.5847 35.0938C38.7503 31.1981 41.3589 25.6501 41.359 19.4932L40.0005 19.4932Z"
                    fill="black"
                    mask="url(#path-3-inside-1_1711_7683)" />
                <circle cx="76.4519" cy="20.0002" r="19.3206" transform="rotate(-180 76.4519 20.0002)" fill="#F4298F" stroke="black" stroke-width="1.35848" />
                <mask id="path-6-inside-2_1711_7683" fill="white">
                    <path
                        d="M61.8785 34.1055C58.5102 30.5261 56.4449 25.7062 56.4449 20.4033C56.4449 14.6382 58.8858 9.4438 62.7886 5.79394C66.1567 9.37333 68.2212 14.1933 68.2212 19.4961C68.2211 25.2612 65.7813 30.4557 61.8785 34.1055Z" />
                </mask>
                <path
                    d="M61.8785 34.1055C58.5102 30.5261 56.4449 25.7062 56.4449 20.4033C56.4449 14.6382 58.8858 9.4438 62.7886 5.79394C66.1567 9.37333 68.2212 14.1933 68.2212 19.4961C68.2211 25.2612 65.7813 30.4557 61.8785 34.1055Z"
                    fill="#FFBC7A" />
                <path
                    d="M61.8785 34.1055L60.8891 35.0364L61.8172 36.0227L62.8064 35.0977L61.8785 34.1055ZM56.4449 20.4033L55.0864 20.4033L55.0864 20.4033L56.4449 20.4033ZM62.7886 5.79394L63.778 4.86299L62.8499 3.87669L61.8607 4.80173L62.7886 5.79394ZM68.2212 19.4961L69.5797 19.4961L69.5797 19.4961L68.2212 19.4961ZM61.8785 34.1055L62.8678 33.1745C59.7269 29.8368 57.8034 25.3463 57.8034 20.4033L56.4449 20.4033L55.0864 20.4033C55.0864 26.0661 57.2934 31.2154 60.8891 35.0364L61.8785 34.1055ZM56.4449 20.4033L57.8034 20.4033C57.8034 15.03 60.0766 10.1901 63.7165 6.78616L62.7886 5.79394L61.8607 4.80173C57.6949 8.69749 55.0864 14.2463 55.0864 20.4033L56.4449 20.4033ZM62.7886 5.79394L61.7993 6.72489C64.9398 10.0625 66.8628 14.5531 66.8628 19.4961L68.2212 19.4961L69.5797 19.4961C69.5797 13.8336 67.3736 8.68418 63.778 4.86299L62.7886 5.79394ZM68.2212 19.4961L66.8628 19.4961C66.8627 24.8695 64.5903 29.7095 60.9506 33.1132L61.8785 34.1055L62.8064 35.0977C66.9723 31.2019 69.5796 25.6529 69.5797 19.4961L68.2212 19.4961Z"
                    fill="black"
                    mask="url(#path-6-inside-2_1711_7683)" />
            </svg>
        </div>

        <!-- Text + radio section -->
        <fieldset class="flex flex-col gap-2 w-full mb-6">
            <legend class="sr-only">Are you a Manager?</legend>
            <p class="text-ink title-body">Are you a Manager?</p>
            <p class="text-ink-muted body">Tailor coaching to your role</p>

            <BaseRadioGroup v-model="selectedValue" :options="managerOptions" orientation="horizontal" aria-label="Are you a Manager?" class="mt-1" />
        </fieldset>

        <!-- Confirm button -->
        <BaseButton theme="secondary" class="w-full" :disabled="!selectedValue" @click="handleConfirm">Confirm</BaseButton>
    </BaseCard>
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import BaseRadioGroup from "~vue/components/form/BaseRadioGroup.vue";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { computed, onMounted, ref } from "vue";

const emit = defineEmits<{ success: [selection: string] }>();
const selectedValue = ref("");
const managerOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
];

onMounted(() => logUserInteraction(AmplitudeEventNames.MANAGER_CARD_SHOWN));

const { execute: sendManagerSelection } = useFetch("/api/accounts/user", { immediate: false })
    .put(
        computed(() => ({
            is_manager: selectedValue.value === "yes",
        })),
    )
    .json();

const handleConfirm = async () => {
    await sendManagerSelection();
    logUserInteraction(AmplitudeEventNames.MANAGER_CARD_SUBMITTED, { is_manager: selectedValue.value === "yes" });
    emit("success", selectedValue.value);
};
</script>
